export const DASHBOARD_URL: string = import.meta.env.VITE_DASHBOARD_URL;
export const API_URL: string = import.meta.env.VITE_API_URL;
export const AUTH_API_URL: string = import.meta.env.VITE_AUTH_API_URL;
export const GRAPHQL_API_URL: string = import.meta.env.VITE_GRAPHQL_API_URL;
export const DATADOG_TOKEN: string = import.meta.env.VITE_DATADOG_TOKEN;
export const DATADOG_APPLICATION_ID = import.meta.env
  .VITE_DATADOG_APPLICATION_ID!;
export const DATADOG_APP_HOSTNAME = import.meta.env.VITE_DATADOG_APP_HOSTNAME!;
export const RUDDERSTACK_API_KEY: string = import.meta.env
  .VITE_RUDDERSTACK_API_KEY;

export const GAINSIGHT_SCRIPT_SDK_LINK: string = import.meta.env
  .VITE_GAINSIGHT_SCRIPT_SDK_LINK;
export const GAINSIGHT_TAG_KEY: string = import.meta.env.VITE_GAINSIGHT_TAG_KEY;

export const IS_PRODUCTION = import.meta.env.MODE === "production";

export const ALLOWED_ENVIRONMENTS = ["production", "staging"];

export const API_VERSIONS = {
  v1: "v1/",
  v3: "v3/",
  v4: "v4/",
  merlin: "merlin/",
};

export enum ENVIRONMENT_CONSTANTS {
  DEVELOPMENT = "development",
  STAGING = "staging",
  PRODUCTION = "production",
  TEST = "test",
}
